import { useState, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router-dom'
import i18nStore from '../stores/i18nStore'
import {
	TextField,
	Button,
	Typography,
	Paper,
	Container,
	Alert
} from '@mui/material'
import logger from '../utils/logger'
import { authErrorMessage } from '../auth/authErrors'
import sessionStore from '../stores/sessionStore'

function ForgotPassword() {
	const navigate = useNavigate()
	const [email, setEmail] = useState('')
	const [error, setError] = useState('')
	const [message, setMessage] = useState('')
	const [loading, setLoading] = useState(false)

	// Инициализируем переводы при загрузке компонента
	useEffect(() => {
		const initI18n = async () => {
			// Если переводы еще не загружены
			if (!i18nStore.translations || Object.keys(i18nStore.translations).length === 0) {
				await i18nStore.initializeLanguage();
			}
		};
		
		initI18n();
	}, []);

	const handleReset = async e => {
		e.preventDefault()
		setError('')
		setMessage('')
		setLoading(true)
		try {
			await sessionStore.forgotPassword(email)
			setMessage(i18nStore.translations?.forgotPassword?.successMessage || 'Ссылка на сброс пароля отправлена. Проверьте почту.')
		} catch (err) {
			logger.error('Password recovery failed', { name: err.name })
			setError(authErrorMessage(err))
		} finally {
			setLoading(false)
		}
	}

	return (
		<Container component='main' maxWidth='xs'>
			<Paper elevation={3} style={{ padding: 20, marginTop: 40 }}>
				<Typography variant='h5' style={{ marginBottom: 20 }}>
					{i18nStore.translations?.forgotPassword?.title || 'Восстановить пароль'}
				</Typography>
				{error && (
					<Alert severity='error' style={{ marginBottom: 20 }}>
						{error}
					</Alert>
				)}
				{message && (
					<Alert severity='success' style={{ marginBottom: 20 }}>
						{message}
					</Alert>
				)}
				<form onSubmit={handleReset}>
					<TextField
						variant='outlined'
						margin='normal'
						required
						fullWidth
						label={i18nStore.translations?.login?.email || 'Электронная почта'}
						autoComplete='email'
						size='small'
						value={email}
						onChange={e => setEmail(e.target.value)}
						disabled={loading}
					/>
					<Button
						type='submit'
						fullWidth
						variant='contained'
						color='primary'
						style={{ margin: '24px 0 16px' }}
						disabled={loading}
					>
						{i18nStore.translations?.forgotPassword?.submit || 'Отправить письмо'}
					</Button>
				</form>
				<Button
					fullWidth
					variant='outlined'
					color='primary'
					onClick={() => navigate('/login')}
					disabled={loading}
				>
					{i18nStore.translations?.forgotPassword?.backToLogin || 'На страницу логина'}
				</Button>
			</Paper>
		</Container>
	)
}

export default observer(ForgotPassword)
